// JS PDF
import jsPDF from "jspdf";

interface HeaderConfig {
  output: boolean;
  margin?: number;
  title: string;
  subTitle: string;
  textFillColor?: string;
}

export default function header(doc: jsPDF, config: HeaderConfig) {
  const output = config.output;
  const margin = config.margin || 10;

  // We want to return the height of the page 1 header and the height of the page 2 header
  const mainHeaderHeight = mainHeader(doc, config);

  // Lets add this to the doc object
  doc.mainHeaderHeight = mainHeaderHeight ?? margin;
  doc.runningHeaderHeight = mainHeaderHeight ?? margin;

  // Run the running header function
  if (output) {
    // Run this for every page
    const pageCount = doc.getNumberOfPages();
    for (var i = 2; i <= pageCount; i++) {
      // Set the page
      doc.setPage(i);

      // Run the running header function
      runningHeader(doc, config);
    }
  }
}

function runningHeader(doc: jsPDF, config: HeaderConfig) {
  let runningHeaderHeight = 0;
  let output = config.output;
  let margin = config.margin || 10;
  const textFillColor = config.textFillColor || "#294F43";

  if (output && doc.getCurrentPageInfo().pageNumber == 1) {
    return runningHeaderHeight;
  }

  // Title maxWidth
  let dateMaxWidth = 60;
  let titleMaxWidth =
    doc.internal.pageSize.getWidth() - margin * 2 - dateMaxWidth;

  let startY = 0;
  startY = margin + 2;

  // Split the title into multiple lines if needed
  const subTitle = config.subTitle;
  const title = config.title;

  // Lets Start adding this to the page
  doc.setFontSize(14);
  doc.setFont("Inter", "bold");
  doc.setTextColor(textFillColor);
  doc.text(title, margin, startY, {
    align: "left",
    maxWidth: titleMaxWidth,
    baseline: "bottom",
  });

  // Need to get the height of the subtitle
  const titleHeight = doc.getTextDimensions(title);

  // Add the subtitle and the date to the page
  doc.setFontSize(9);
  doc.setFont("Inter", "normal");
  doc.setTextColor("#616161");
  doc.text(subTitle.trim(), doc.internal.pageSize.getWidth() - margin, startY, {
    align: "right",
    maxWidth: dateMaxWidth,
    baseline: "bottom",
  });

  // Need to get the height of the subtitle
  const subTitleHeight = doc.getTextDimensions(subTitle);

  // Reset the char space
  doc.setCharSpace(0);

  // Now we need to return the height of the header
  if (titleHeight.h > subTitleHeight.h) {
    runningHeaderHeight = titleHeight.h;
  } else {
    runningHeaderHeight = subTitleHeight.h;
  }

  // Add the margin to the mainHeaderHeight
  runningHeaderHeight += startY;

  if (!output) {
    // If we are not outputting the header, we need to delete the page we just created
    let pageNumber = doc.getCurrentPageInfo().pageNumber;
    doc.deletePage(pageNumber);
    doc.addPage();
  }

  return runningHeaderHeight;
}

function mainHeader(doc: jsPDF, config: HeaderConfig) {
  let mainHeaderHeight = 0;
  let startY = 0;
  const output = config.output;
  const margin = config.margin || 10;
  const textFillColor = config.textFillColor || "#294F43";

  // Title maxWidth
  let dateMaxWidth = 60;
  let titleMaxWidth =
    doc.internal.pageSize.getWidth() - margin * 2 - dateMaxWidth;

  doc.setPage(1);

  startY = margin + 2;

  // Split the title into multiple lines if needed
  const subTitle = config.subTitle;
  const title = config.title;

  // Lets Start adding this to the page
  doc.setFontSize(14);
  doc.setTextColor(textFillColor);
  doc.setFont("Inter", "bold");
  doc.text(title, margin, startY, {
    align: "left",
    maxWidth: titleMaxWidth,
    baseline: "bottom",
  });

  // Need to get the height of the subtitle
  const titleHeight = doc.getTextDimensions(title);

  // Add the subtitle and the date to the page
  doc.setFontSize(9);
  doc.setFont("Inter", "normal");
  doc.setTextColor("#616161");
  doc.text(subTitle.trim(), doc.internal.pageSize.getWidth() - margin, startY, {
    align: "right",
    maxWidth: dateMaxWidth,
    baseline: "bottom",
  });

  // Need to get the height of the subtitle
  const subTitleHeight = doc.getTextDimensions(subTitle);

  // Reset the char space
  doc.setCharSpace(0);

  // Now we need to return the height of the header
  if (titleHeight.h > subTitleHeight.h) {
    mainHeaderHeight = titleHeight.h;
  } else {
    mainHeaderHeight = subTitleHeight.h;
  }

  if (!output) {
    // If we are not outputting the header, we need to delete the page we just created
    let pageNumber = doc.getCurrentPageInfo().pageNumber;
    doc.deletePage(pageNumber);
    doc.addPage();
  }

  // Add the margin to the mainHeaderHeight
  mainHeaderHeight += startY;

  return mainHeaderHeight;
}
